// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"leaderboard"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M9 4H15V20H9V4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M15 12H21V20H15V12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M3 10H9V20H3V10Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 20V4H9V20M15 20H9M15 20V12H21V20H15ZM9 20V10H3V20H9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-leaderboard')
export default class LeaderboardIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'leaderboard',
    }
  }
}
